import {
  isDockerEnvironment,
  isKubernetesEnvironment,
} from '@/react/portainer/environments/utils';
import {
  AppliedPolicyStatus,
  AppliedPolicyStatusType,
  EnvironmentType,
} from '@/react/portainer/environments/types';

import { EnvironmentInfo, PolicyEnvironmentType, PolicyType } from '../types';

// isEnvironmentSupportedByPolicy checks if a given environment supports the specified policy type as per the response
// from the backend.
export function isEnvironmentSupportedByPolicy(
  environment: EnvironmentInfo,
  policyType: PolicyType
) {
  const policyStatus = getEnvironmentPolicyStatus(environment, policyType);

  return policyStatus.Status !== AppliedPolicyStatusType.NotSupported;
}

export function getEnvironmentPolicyStatus(
  environment: EnvironmentInfo,
  policyType: PolicyType
): AppliedPolicyStatus {
  const fallback = {
    Status: AppliedPolicyStatusType.NotSupported,
    Message: 'Not supported',
  };
  switch (policyType) {
    case 'rbac-docker':
      return environment.Policies?.dockerRBACPolicy?.policyStatus ?? fallback;
    case 'rbac-k8s':
      return environment.Policies?.k8sRBACPolicy?.policyStatus ?? fallback;
    case 'security-k8s':
      return environment.Policies?.k8sSecurityPolicy?.policyStatus ?? fallback;
    case 'security-docker':
      return (
        environment.Policies?.dockerSecurityPolicy?.policyStatus ?? fallback
      );
    case 'setup-k8s':
      return environment.Policies?.k8sSetupPolicy?.policyStatus ?? fallback;
    case 'setup-docker':
      return environment.Policies?.dockerSetupPolicy?.policyStatus ?? fallback;
    case 'registry-k8s':
      return environment.Policies?.k8sRegistryPolicy?.policyStatus ?? fallback;
    case 'registry-docker':
      return (
        environment.Policies?.dockerRegistryPolicy?.policyStatus ?? fallback
      );
    default:
      return fallback;
  }
}

// isEnvironmentTypeSupportedByPolicy checks if a given environment type is compatible with the specified policy environment type.
export function isEnvironmentTypeSupportedByPolicy(
  environmentType: EnvironmentType,
  policyRequiredType: PolicyEnvironmentType
) {
  if (policyRequiredType === 'kubernetes') {
    return isKubernetesEnvironment(environmentType);
  }
  if (
    policyRequiredType === 'docker' ||
    policyRequiredType === 'swarm' ||
    policyRequiredType === 'podman'
  ) {
    return isDockerEnvironment(environmentType);
  }

  return false;
}
